import React from "react";
import { Box, Container, Typography } from "@mui/material";
import StorePolicy from "../../common/component/StorePolicy";

export default function StorePolicyPage(props) {
  return (
    <Box pt={4} pb={10}>
      <Container maxWidth="md">
        <Box>
          <Typography variant="h1" gutterBottom>
            Store Policy
          </Typography>
          <Typography variant="body1" gutterBottom>
            The following policies are applicable to all orders placed online, in-store and over the phone.
          </Typography>
        </Box>
        <StorePolicy />
      </Container>
    </Box>
  );
}
